import alt from "@cirrus/legacy/app-author/alt/alt.es6"

const ConfirmationDialogActions = alt.generateActions("show", "hide", "submitted")
export default alt.createActions(ConfirmationDialogActions)
